import { useState, useEffect, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { OrderModel } from '../../models/orders/order-list-model';
import myOrderServices from '../../services/orders/myorder.service';
import MyOrderDataTable from './my-order-datatable';
import AppLoading from '../app-loading/app-loading';
import orderServices from '../../services/orders/orderservice';
 
interface OrderFilterRequest {
    Year: number;
    PageNumber: number;
    PageSize: number;
    Keyword?: string | null;
}
 
const MyOrderList = () => {
    const { t } = useTranslation();
    const [orderList, setOrderList] = useState<OrderModel[]>([]);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const currentYear = new Date().getFullYear();
    const [filterYear, setFilterYear] = useState<number>(currentYear);
    const [searchKeyword, setSearchKeyword] = useState<string | null>(null);
    const [orderIds,setOrderIds] = useState<any>();

    useEffect(() => {
        fetchOrders(searchKeyword);
        FeatchOrderIds();
    }, [pageNumber, pageSize, filterYear, searchKeyword]);
 
    function fetchOrders(keyword: string | null = null) {    
        setLoading(true);
        const requestBody: OrderFilterRequest = {
            Year: filterYear,
            PageNumber: pageNumber,
            PageSize: pageSize,
            Keyword: keyword || null
        };
       
        myOrderServices.getMyOrders1(requestBody).then((response: any) => {
            if (response?.orders) {
                const normalizedData = response.orders.map((order: any) => ({
                    ...order,
                    orderDetail: order.orderDetail || []
                }));
                const sortedData = [...normalizedData].sort((a, b) => b.orderID - a.orderID);
                setOrderList(sortedData);
                setTotalRecords(response.totalRecords);
            } else {
                setOrderList([]);
                setTotalRecords(0);
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    }

    const FeatchOrderIds = async () => {
        await  orderServices.GetPullPaymentStatusLogs().then((orderIdList: any[]) => {
        setOrderIds(orderIdList);
    });
    }
 
    const handlePageChange = (event: any) => {
        setPageNumber(event.page + 1);
        setPageSize(event.rows);
    };
 
    const handleYearChange = (year: number) => {
        setFilterYear(year);
        setPageNumber(1);
    };
 
    const handleSearch = (keyword: string | null) => {
        setSearchKeyword(keyword);
        setPageNumber(1);
    };
 
    function handleOrderCancelled (keyword: string | null = null) {    
        setLoading(false);
        const requestBody: OrderFilterRequest = {
            Year: filterYear,
            PageNumber: pageNumber,
            PageSize: pageSize,
            Keyword: keyword || null
        };
       
        myOrderServices.getMyOrders1(requestBody).then((response: any) => {
            if (response?.orders) {
                const normalizedData = response.orders.map((order: any) => ({
                    ...order,
                    orderDetail: order.orderDetail || []
                }));
                const sortedData = [...normalizedData].sort((a, b) => b.orderID - a.orderID);
                setOrderList(sortedData);
                setTotalRecords(response.totalRecords);
            } else {
                setOrderList([]);
                setTotalRecords(0);
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    }
 
    return (
        <Suspense fallback={<AppLoading />}>
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
            <div className="col-12">                
                {/* <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
                    <h5 className="ml-1 mb-0">{t('myOrders_myOrders')}</h5>                    
                </div> */}
            </div>
            {loading ? (
                    <AppLoading />
                ):
            <MyOrderDataTable
                data={orderList}
                pageNumber={pageNumber}
                pageSize={pageSize}
                totalRecords={totalRecords}
                onPageChange={handlePageChange}
                onYearChange={handleYearChange}
                filterYear={filterYear}
                onOrderCancelled={handleOrderCancelled}
                onSearch={handleSearch}
                searchKeyword={searchKeyword}
            />}
        </div>
        </Suspense>
    );
};
 
export default MyOrderList;
